module.exports = new __parcel__URL__("office.79761463.jpg").toString();